import './Footer.css';

const footerLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Contact', href: '#contact' }
];

function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="footer__inner">
        <div className="footer__brand">
          <p className="footer__eyebrow">Private Web Services</p>
          <p className="footer__title">Clean builds for focused businesses.</p>
        </div>

        <nav className="footer__links" aria-label="Footer links">
          {footerLinks.map((link) => (
            <a key={link.label} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="footer__meta">
          <a href="mailto:hello@devlab.studio">Devlab.preventivi@gmail.com</a>
          <span>© 2026 DevLab</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;